module.exports = __webpack_public_path__ + "static/media/176.1f4a8282.mp3";